import { getItem, setItem } from './local'

export function getCurrentUser () {
  return getItem('user')
}

export function storeUser (userInfo) {
  return setItem('user', userInfo)
}
